import { Button } from "@website/ui/button";
import { Modal, ModalPropertiesType } from "@website/ui/modal";
import { isSSR } from "@website/utils/is-ssr";
import { FC, memo } from "react";
import { createPortal } from "react-dom";

export type SnappPayDetailsModalProperties = ModalPropertiesType;

const Component: FC<SnappPayDetailsModalProperties> = ({ ...properties }) => {
  if (isSSR()) return <div />;

  return createPortal(
    <Modal
      {...properties}
      mobileHeight="auto"
      showCloseButton
      title="پرداخت اقساطی با اسنپ‌پی"
    >
      <div className="mt-5 flex flex-col gap-6">
        <span>
          پرداخت
          <span className="font-bold"> ۴ قسطه </span>
          اسنپ‌پی،{" "}
          <span className="font-bold">بدون نیاز به ضامن، چک و سفته </span>
          انجام می‌شود.
        </span>
        <ul className="flex list-disc flex-col gap-1 px-5 font-light">
          <li>قسط اول را موقع خرید و نقدی پرداخت می‌کنید.</li>
          <li>
            درصورتی‌که مبلغ خرید بیشتر از اعتبارتان باشد، مابه‌تفاوت را همراه
            قسط اول پرداخت می‌کنید.
          </li>
        </ul>
        <div className="flex flex-col gap-4">
          <div className="flex flex-row items-center justify-between text-xs">
            <div className="text-on-surface-medium-emphasis flex flex-col">
              <span>مثال ۱</span>
              <span className="font-semibold">مبلغ خرید بیشتر از اعتبار</span>
            </div>
            <div className="flex flex-row items-center">
              <div className="flex flex-col">
                <span className="text-on-surface-medium-emphasis">
                  مبلغ خرید
                </span>
                <span>۴ میلیون تومان</span>
              </div>
              <span className="text-on-surface-medium-emphasis ml-2 mr-1 text-xs">
                {"<"}
              </span>
              <div className="flex flex-col">
                <span className="text-on-surface-medium-emphasis">
                  اعتبار شما
                </span>
                <span>۲ میلیون تومان</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 items-center gap-[2px]">
            <div className="bg-dim-background flex h-[52px] flex-col items-center justify-center rounded-r-full">
              <span className="text-xs font-light">قسط اول</span>
              <span className="font-semibold">۲٫۵ میلیون تومان</span>
            </div>
            <div className="text-ventures-fin-tech bg-transparent-secondary flex h-[52px] flex-col items-center justify-center rounded-l-full">
              <span className="text-xs font-light">سه قسط بعدی (هرکدام)</span>
              <span className="font-semibold">۵۰۰ هزار تومان</span>
            </div>
          </div>
        </div>
        {/*  */}
        <div className="border-outline-thin w-full border border-dotted" />
        {/*  */}
        <div className="flex flex-col gap-4">
          <div className="flex flex-row items-center justify-between text-xs">
            <div className="text-on-surface-medium-emphasis flex flex-col">
              <span>مثال ۲</span>
              <span className="font-semibold">مبلغ خرید کمتر از اعتبار</span>
            </div>
            <div className="flex flex-row items-center">
              <div className="flex flex-col">
                <span className="text-on-surface-medium-emphasis">
                  مبلغ خرید
                </span>
                <span>۲ میلیون تومان</span>
              </div>
              <span className="text-on-surface-medium-emphasis ml-2 mr-1 text-xs">
                {"=<"}
              </span>
              <div className="flex flex-col">
                <span className="text-on-surface-medium-emphasis">
                  اعتبار شما
                </span>
                <span>۲ میلیون تومان</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 items-center gap-[2px]">
            <div className="bg-dim-background flex h-[52px] flex-col items-center justify-center rounded-r-full">
              <span className="text-xs font-light">قسط اول</span>
              <span className="font-semibold">۵۰۰ هزار تومان</span>
            </div>
            <div className="text-ventures-fin-tech bg-transparent-secondary flex h-[52px] flex-col items-center justify-center rounded-l-full">
              <span className="text-xs font-light">سه قسط بعدی (هرکدام)</span>
              <span className="font-semibold">۵۰۰ هزار تومان</span>
            </div>
          </div>
        </div>
        <div className="flex w-full justify-end">
          <Button
            color="secondary"
            onClick={properties.onClose}
            type="button"
            variant="contained"
          >
            متوجه شدم
          </Button>
        </div>
      </div>
    </Modal>,
    document.body
  );
};

export const SnappPayDetailsModal = memo(Component);
